import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, setToken } from '../../lib/api';
import { useAdmin } from '../../lib/auth';
import Logo from '../../components/Logo';

export default function AdminLogin() {
    const nav = useNavigate();
    const { signIn, admin } = useAdmin();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [busy, setBusy] = useState(false);

    React.useEffect(() => { if (admin) nav('/', { replace: true }); }, [admin, nav]);

    const login = async () => {
        setError(''); setBusy(true);
        try {
            const r = await api.post('/admin/auth/login', { email: email.trim().toLowerCase(), password });
            signIn(r.data.access_token, r.data.admin);
            nav('/', { replace: true });
        } catch (e) {
            setError(e.response?.data?.detail || 'Login failed');
        } finally { setBusy(false); }
    };

    return (
        <div className="min-h-screen bg-sdf-ivory flex flex-col">
            <div className="px-4 py-8 border-b border-sdf-line flex items-center justify-center"><Logo variant="login" /></div>
            <main className="flex-1 flex items-start justify-center px-4 pt-16">
                <div className="w-full max-w-sm">
                    <h1 className="text-2xl font-extrabold">Admin Sign In</h1>
                    <p className="mt-1 text-sm text-sdf-text-2">Access the admin dashboard.</p>
                    <div className="mt-6 card-soft p-5 space-y-3">
                        <Input label="Email" type="email" value={email} onChange={setEmail} tid="admin-email" />
                        <Input label="Password" type="password" value={password} onChange={setPassword} tid="admin-password" />
                        {error && <div className="text-sm text-red-700 rounded bg-red-50 border border-red-200 px-3 py-2" data-testid="admin-login-error">{error}</div>}
                        <button onClick={login} disabled={busy} className="btn-red-lg" data-testid="admin-login-btn">{busy ? 'Signing in…' : 'Sign In'}</button>
                    </div>
                </div>
            </main>
        </div>
    );
}

function Input({ label, type = 'text', value, onChange, tid }) {
    return (
        <div>
            <label className="text-[10px] font-bold text-sdf-text-2 tracking-widest">{label.toUpperCase()}</label>
            <input type={type} value={value} onChange={(e) => onChange(e.target.value)} className="mt-1.5 w-full border border-sdf-line rounded-xl px-3 py-3 outline-none text-sm bg-white" data-testid={tid} />
        </div>
    );
}
